import { render, staticRenderFns } from "./PageFeedTdk.vue?vue&type=template&id=259236a2&scoped=true&"
import script from "./PageFeedTdk.vue?vue&type=script&lang=js&"
export * from "./PageFeedTdk.vue?vue&type=script&lang=js&"
import style0 from "./PageFeedTdk.vue?vue&type=style&index=0&id=259236a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259236a2",
  null
  
)

export default component.exports